import React, { Component } from 'react';
import logo from '../images/logo.svg';
import {FaAlignRight} from "react-icons/fa";
import { FiAward } from "react-icons/fi";
import {Link} from 'react-router-dom';

export default class Navbar extends Component {


    render() {
        return (
            <div> hello im navbar   </div>
        )
    }
}
